import React from "react";

const TelegramIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path
        stroke="#FFF"
        d="M12 .5c3.176 0 6.05 1.287 8.132 3.368A11.464 11.464 0 0 1 23.5 12c0 3.176-1.287 6.05-3.368 8.132A11.464 11.464 0 0 1 12 23.5c-3.176 0-6.05-1.287-8.132-3.368A11.464 11.464 0 0 1 .5 12c0-3.176 1.287-6.05 3.368-8.132A11.464 11.464 0 0 1 12 .5z"
      />
      <path fill="#FFF" d="m10.206 14.334-.093 2.372 1.225-1.494-1.132-.878" />
      <path
        fill="#FFF"
        d="M16.879 7.026c-1.955.786-8.266 3.416-10.654 4.413a.366.366 0 0 0 .032.687l2.74.854 6.14-3.723c.037-.022.076.028.044.058l-4.695 4.463s2.887 2.114 4.256 3.112a.568.568 0 0 0 .893-.353l1.714-9.125a.347.347 0 0 0-.47-.386"
      />
    </g>
  </svg>
);

export default TelegramIcon;
